import { Card, Col, Row, Table } from "react-bootstrap";

export const RoomCategoryControl = ({ summaryByCategory }) => {

  if (!summaryByCategory || summaryByCategory.length === 0) {
    return null; // Render nothing if summaryByCategory is empty or undefined
  }

  return (
    <>
      <Row>
        <Col sm={12} className="col-12">
          <Card>
            <Card.Header>
              <h3 className="card-title mb-0">Habitaciones por categoria</h3>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <Table className="table text-nowrap text-md-nowrap mg-b-0">
                  <thead>
                    <tr>
                      <th>Categoria</th>
                      <th>Cantidad</th>
                      <th>Vendidas</th>
                      <th>Disponibles</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      summaryByCategory.map((category, index) => (
                        <tr key={index}>
                          <td>{category.name}</td>
                          <td className="text-center" >{category.quantity}</td>
                          <td className="text-center" >{category.sold}</td>
                          <td className="text-center" >{category.quantity - category.sold}</td>
                        </tr>
                      ))
                    }
                    <tr style={{ fontWeight: "bold" }}>
                      <td>Total</td>
                      <td className="text-center" >{summaryByCategory.reduce((total, category) => total + category.quantity, 0)}</td>
                      <td className="text-center" >{summaryByCategory.reduce((total, category) => total + category.sold, 0)}</td>
                      <td className="text-center" >{summaryByCategory.reduce((total, category) => total + (category.quantity - category.sold), 0)}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}
